(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wonder-video-carousel-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wonder-video-carousel')) {
    customElements.define('wonder-video-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-video-track]');
        if (!this.track) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.previous = this.querySelector('[data-video-previous]');
        this.next = this.querySelector('[data-video-next]');
        this.previous.addEventListener('click', () => this.step(-1), options);
        this.next.addEventListener('click', () => this.step(1), options);
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.step(event.key === 'ArrowLeft' ? -1 : 1);
          }
        }, options);
        this.track.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          if (event.target.closest('button, a, input')) return;
          this.drag = { id: event.pointerId, x: event.clientX, scroll: this.track.scrollLeft, moved: false };
          this.suppressClick = false;
        }, options);
        this.track.addEventListener('pointermove', event => {
          const drag = this.drag;
          if (!drag || drag.id !== event.pointerId) return;
          if (!drag.moved && Math.abs(event.clientX - drag.x) < 7) return;
          if (!drag.moved) {
            drag.moved = true;
            this.track.setPointerCapture(event.pointerId);
            this.track.classList.add('is-dragging');
          }
          event.preventDefault();
          this.track.scrollLeft = drag.scroll + drag.x - event.clientX;
        }, options);
        const finish = event => {
          if (!this.drag || this.drag.id !== event.pointerId) return;
          this.suppressClick = this.drag.moved;
          this.drag = null;
          this.track.classList.remove('is-dragging');
          if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
          this.update();
        };
        window.addEventListener('pointerup', finish, options);
        window.addEventListener('pointercancel', finish, options);
        this.track.addEventListener('lostpointercapture', finish, options);
        this.track.addEventListener('click', event => {
          if (!this.suppressClick) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.suppressClick = false;
        }, { ...options, capture: true });
        this.track.addEventListener('dragstart', event => event.preventDefault(), options);
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('[data-video-card]');
          if (!card || !this.track.contains(card)) return;
          this.track.scrollTo({ left: card.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft, behavior: 'instant' });
        }, options);
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.visibleVideos = new Set();
        this.videoObserver = new IntersectionObserver(entries => {
          entries.forEach(({ target: video, isIntersecting, intersectionRatio }) => {
            if (isIntersecting && intersectionRatio >= .2) this.visibleVideos.add(video);
            else this.visibleVideos.delete(video);
          });
          this.syncPlayback();
        }, { threshold: [0, .2] });
        this.track.querySelectorAll('video').forEach(video => {
          video.muted = true;
          video.defaultMuted = true;
          video.loop = true;
          this.videoObserver.observe(video);
        });
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        this.update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        this.videoObserver?.disconnect();
        this.track?.querySelectorAll('video').forEach(video => video.pause());
        this.track?.classList.remove('is-dragging');
        this.drag = null;
      }
      syncPlayback() {
        this.track.querySelectorAll('video').forEach(video => {
          if (!document.hidden && this.visibleVideos.has(video)) {
            video.muted = true;
            video.play().catch(() => {});
          } else video.pause();
        });
      }
      step(direction) {
        const card = this.track.querySelector('[data-video-card]');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
